export function makePrezlyLinkRelative(href: string) {
    if (href.includes('www.prezly.com')) {
        return href.replace(/^[a-zA-Z]{3,5}:\/{2}[a-zA-Z0-9_.:-]+\//, '/');
    }

    return href;
}
